












import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Muntah extends Vue {
  @Prop() setMuntah: string;
  // muntah = "";
  // @Watch("muntah")
  // changeMuntah(v) {
  //   this.$emit("muntah", v);
  // }
  @Watch("setMuntah")
  change(v) {
    this.$emit("muntah", v);
    // this.muntah = v;
  }
  // get muntah() {
  //   return this.setMuntah;
  // }
  // set muntah(v) {
  //   this.$emit("muntah", v);
  // }
}
